import React from 'react';
import ReactDOM from 'react-dom';
import { FieldList } from './FieldList';

export const initCaseTriageForm = () => {
  const target = document.getElementById('triage-pending-info');
  if (target) {
    ReactDOM.render(
      <FieldList />,
      target
    )
  }
};
